// Insights list — editorial list hover states and scroll entrance
import { gsap } from '../gsap-config.js';
import { initAnimationsForElement } from '../utils/animations.js';
import { initSectionGhostFloat } from '../utils/section-ghost-float.js';
import { prefersReducedMotion } from '../utils/media.js';

function cleanupSection(section) {
	section._insightsListAbort?.abort();
	section._insightsListAbort = null;

	section.querySelectorAll('[data-insights-list-item]').forEach((item) => {
		item.classList.remove('is-active');
	});
	section.classList.remove('is-hovered');
}

function setActiveItem(section, item) {
	section.querySelectorAll('[data-insights-list-item].is-active').forEach((active) => {
		if (active !== item) active.classList.remove('is-active');
	});

	if (item) {
		section.classList.add('is-hovered');
		item.classList.add('is-active');
		return;
	}

	section.classList.remove('is-hovered');
}

function initInsightsList() {
	const reducedMotion = prefersReducedMotion();

	document.querySelectorAll('[data-insights-list-init]').forEach((section) => {
		cleanupSection(section);

		const items = Array.from(section.querySelectorAll('[data-insights-list-item]'));
		if (!items.length) return;

		const abort = new AbortController();
		section._insightsListAbort = abort;
		const listenerOptions = { signal: abort.signal };

		const list = section.querySelector('.insights-list__items');

		items.forEach((item) => {
			const link = item.querySelector('.insights-list__item-link');
			if (!link) return;

			link.addEventListener('mouseenter', () => setActiveItem(section, item), listenerOptions);

			link.addEventListener(
				'focusin',
				() => setActiveItem(section, item),
				listenerOptions
			);

			link.addEventListener(
				'focusout',
				(event) => {
					if (item.contains(event.relatedTarget)) return;
					if (!section.querySelector('.insights-list__item-link:focus')) {
						setActiveItem(section, null);
					}
				},
				listenerOptions
			);
		});

		list?.addEventListener('mouseleave', () => setActiveItem(section, null), listenerOptions);

		if (!reducedMotion) {
			const triggerEl = section.querySelector('.insights-list__items') || section;
			const triggerTop = triggerEl.getBoundingClientRect().top;
			const alreadyVisible = triggerTop < window.innerHeight * 0.82;

			if (!alreadyVisible) {
				gsap.from(items, {
					scrollTrigger: {
						trigger: triggerEl,
						start: 'top 82%',
						once: true,
					},
					y: 48,
					autoAlpha: 0,
					stagger: 0.1,
					duration: 0.85,
					ease: 'power2.out',
					clearProps: 'all',
				});
			}
		}

		initSectionGhostFloat(section);
	});
}

function bootstrap() {
	requestAnimationFrame(() => {
		const island = document.querySelector('is-land[type="insights-list"]');
		if (island) {
			initAnimationsForElement(island);
		}
	});

	if (document.querySelector('[data-insights-list-init]')) {
		initInsightsList();
	}
}

bootstrap();
